export default {
  title: 'Notificações de faturas',
  new: {
    title: 'Nova delegação',
    single: 'Delegação',
    action: 'Adicionar configuração'
  },
  provider: 'Email do fornecedor',
  acc: {
    first: 'Avisos de faturas a cobrar',
    second: 'Avisos de autofaturas a cobrar',
    third: 'Avisos de faturas a pagar',
    fourth: 'Avisos de autofaturas a pagar'
  },
  copy: 'Copiar configuração da fatura',
  form: {
    language: 'Idioma',
    email: 'Email*',
    emited: 'Quando for emitida',
    read: 'Quando for lida',
    accepted: 'Quando for aceita',
    refused: 'Quando for rejeitada',
    edited: 'Quando for retificada',
    ignored: 'Quando não for lida em 7 dias'
  },
  delete: {
    title: 'Lista de notificações para excluir',
    success: 'As notificações foram excluídas com sucesso.'
  },
  errors: {
    title: 'Por favor, verifique os seguintes dados',
    unavailable: 'Não é possível criar um novo aviso, pois todas as delegações da Entidade Adscrita têm avisos configurados',
    setup: 'Erro na configuração das notificações.'
  }
}